import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { ApiFinanceira } from '../axiosfinanceiro';

export interface IListagemCheque {
  idcheque: string;
	dataoperacao: Date;
	datadeposito: Date;
	agencia: string;
  banco: string;
	conta: string;
	titular: string;
	valor: number;
	status: number;
	numero: string;
	marcado: boolean;
	nome: string;
	tipostatus: string;
}

export interface ICheque{
  datadeposito: Date;
  emissao: Date;
  idconta: number;
  credor: string;
  valor: number;
  contapagas: boolean;
  idparceiro?: string | null;
  numero: string;
  historico: string;
  status: number,
}

export interface IChequeRelatorio{
   banco: string;
   dataoperacao: Date;
   datadeposito: Date;
   databaixa: Date;
   agencia: string;
   conta: string;
   titular: string;
   valor: number;
   numero: string;
   nome: string;
   tipostatus: string;
}

export interface Ibaixacheque{
  idconta: number;
  databaixa: Date;
}

type TotalCount = {
    data: IListagemCheque[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const getAll = async (page = 1, filter = '', tipo='', datainicial: string, datafinal: string): Promise<TotalCount | Error> => {
  try {

    const urlRelativa = `/cheque?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}&tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data, headers } = await ApiFinanceira.get(urlRelativa); 

    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Baixa = async (dadosbaixa: Ibaixacheque, dados: IListagemCheque[]): Promise<void | Error> => {
  try {  
    const baixa = dados.map(conta => {
      return {
        idcheque: conta.idcheque,
        databaixa: dadosbaixa.databaixa,
        idconta: dadosbaixa.idconta,
      };
    });
    await ApiFinanceira.post('/chequebaixa', baixa); 
    return;   
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RelatorioCheque = async (parceiro: string, status: number, conta: number, tipodata: string,  datainicial: string, datafinal: string): Promise<IChequeRelatorio[] | Error> => {
  try {
    const urlRelativa = `/relatoriocheque?parceiro=${parceiro}&tipodata=${tipodata}&conta=${conta}&status=${status}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ChequeService = {  
  getAll,
  Baixa,
  RelatorioCheque,
};